import React, { memo, useEffect } from 'react';

import LoadPlanViewer3D from '../Components/LoadPlanViewer3D';

/**
 * OutboundJobLoadPlanV2
 *
 * Tab wrapper that renders the 3D Load Plan Viewer for the given outbound job.
 * Clears the modal footer actions (no form buttons needed on this tab).
 */
function OutboundJobLoadPlanV2({
  record,
  currentTab,
  onSetModalActions,
}) {
  // Clear modal footer buttons when this tab is active
  useEffect(() => {
    if (currentTab === 'loadPlanV2') {
      onSetModalActions([]);
    }
  }, [currentTab, onSetModalActions]);

  return (
    <LoadPlanViewer3D
      warehouseOutId={record?.Id}
      height="calc(90vh - 180px)"
    />
  );
}

export default memo(OutboundJobLoadPlanV2);
